'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.span.withConfig({
  componentId: 's12ja3bn-0'
})(['display:inline-block;position:relative;line-height:20px;text-align:center;border-radius:', ';background:', ';padding:5px 10px;margin-top:7px;transform:translateX(-50%);&::after{content:\'\';width:0;height:0;position:absolute;left:50%;top:-7px;transform:translateX(-50%);border-left:7px solid transparent;border-bottom:7px solid ', ';border-right:7px solid transparent;}'], function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.borderColor;
}, function (p) {
  return p.theme.borderColor;
});